<template>
  <div class="product-sheet">
    <!-- D : 검색조건선택 -->
    <!-- D: pc 전용 -->
    <div class="c-filter-box">
      <div class="c-form-field only-pc">
        <label class="c-input-calender">
          <input
            type="text"
            title="시작일"
            readonly
            required
            data-datepicker
            ref="orderDateStRef"
            id="orderDateSt"
            v-model="data.biz1.search.searchDateSt"
          />
        </label>
        <span class="tilde">~</span>
        <label class="c-input-calender">
          <input
            type="text"
            title="종료일"
            readonly
            required
            data-datepicker
            ref="orderDateEdRef"
            id="orderDateEd"
            v-model="data.biz1.search.searchDateEd"
          />
        </label>
      </div>

      <div class="c-round-button-box">
        <div
          class="c-radio-round type-black"
          v-for="(item, index) in searchPeriod"
          :key="index"
        >
          <input
            type="radio"
            :id="'filter-date-option2-' + index"
            name="filter-date-option2"
            :value="item.value"
            v-model="data.biz1.search.searchPeriod"
            @change="dateCalculation(item.value)"
          />
          <label :for="'filter-date-option2-' + index">{{ item.name }}</label>
        </div>
      </div>

      <!-- // D: pc 전용 -->
      <!-- D: mo 전용 -->
      <div class="c-form-field only-mo">
        <button
          type="button"
          class="btn-date-select"
          @click="btnCmd('biz1#searchPopup')"
        >
          <span> {{ data.biz1.resDateSt }} ~ {{ data.biz1.resDateEd }} </span>
        </button>
      </div>
      <!-- D: is-active 클래스추가시 메뉴 열림 -->
      <div class="c-mo-toggle-box only-mo">
        <button
          type="button"
          class="selected-text"
          @click="btnCmd('biz1#searchPopup')"
        >
          {{ statusCdNm }}
        </button>
      </div>
      <!-- D: is-active 클래스추가시 메뉴 열림 -->
      <div class="c-mo-toggle-box only-mo">
        <button
          type="button"
          class="selected-text"
          @click="btnCmd('biz1#searchPopup')"
        >
          {{ dlvCdNm }}
        </button>
      </div>
      <!-- // D: is-active 클래스추가시 메뉴 열림 -->
      <!-- // D: mo 전용 -->
      <div class="c-filter-search">
        <form
          class="search-form"
          @submit.prevent
          @click="btnCmd('biz1#searchPopup')"
        >
          <label class="sr-only">주문검색</label>
          <input
            type="search"
            id="searchQuery"
            title="검색"
            class="search-input"
            autocomplete="off"
            placeholder="제품명/제품코드/배송지/인수자 입력"
            v-model="data.biz1.search.searchQuery"
          />
          <button
            type="button"
            class="search-cancel"
            @click="data.biz1.search.searchQuery = ''"
          >
            <i class="c-icon icon-large-x"></i>
            <span class="sr-only">검색어 재입력</span>
          </button>
          <button
            type="submit"
            class="search-submit"
            @click="searchCmd('biz1#search')"
          >
            <span class="sr-only">검색</span>
          </button>
        </form>
      </div>
    </div>
    <!-- // D : 검색조건선택 -->

    <!-- D : 주문상태설정 -->
    <!-- D: pc 전용 -->
    <div class="state-box">
      <div>
        <div class="c-round-button-box">
          <div
            class="c-radio-round type-black"
            v-for="(item, index) in data.codes.code01"
            :key="index"
          >
            <input
              type="radio"
              :id="'filter-state-option1-' + index"
              name="filter-state-option1"
              :value="item.cdVl"
              v-model="data.biz1.search.orderStatusCd"
            />
            <label :for="'filter-state-option1-' + index">{{
              item.cdNm
            }}</label>
          </div>
        </div>
        <div class="c-round-button-box">
          <div
            class="c-radio-round type-black"
            v-for="(item, index) in data.codes.code02"
            :key="index"
          >
            <input
              type="radio"
              :id="'filter-state-option2-' + index"
              name="filter-state-option2"
              :value="item.cdVl"
              v-model="data.biz1.search.selectedDlvCd"
            />
            <label :for="'filter-state-option2-' + index">{{
              item.cdNm
            }}</label>
          </div>
        </div>
      </div>
      <div class="right-box">
        <button
          type="button"
          class="c-util-button type-line-black"
          @click="resetCmd('biz1#reset')"
        >
          <span>초기화</span>
        </button>
        <button
          type="button"
          class="c-util-button type-primary"
          @click="searchCmd('biz1#search')"
        >
          <span>조회</span>
        </button>
      </div>
    </div>
    <!-- // D: pc 전용 -->
    <!-- // D : 주문상태설정 -->

    <!-- D : 주문서 영역 -->
    <div class="c-table-util-box">
      <div class="c-table-top-util">
        <div class="left-box">
          <div class="text-item">
            <strong> 제품별 조회결과 : </strong>
            <span> {{ data.biz1.totalCount }}건 </span>
          </div>
          <div class="text-item type-regular">
            <strong> 주문일자 : </strong>
            <template v-if="data.biz1.resDateSt && data.biz1.resDateEd">
              <span>
                {{ data.biz1.resDateSt }} ~
                {{ data.biz1.resDateEd }}
              </span>
            </template>
          </div>
          <div class="text-item type-regular">
            <strong> 총금액 합계 : </strong>
            <span v-if="data.biz1.list.length > 0">
              {{ Number(data.biz1.list[0].goodsPrcTotal).toLocaleString() }}원
            </span>
          </div>
        </div>
        <div class="right-box">
          <p class="info-txt only-pc" v-if="data.biz1.list.length > 0">
            설정된 기간에 대한 조회 결과가 다운로드 됩니다.
          </p>
          <button
            v-if="data.biz1.list.length > 0"
            type="button"
            class="c-util-button type-line-black"
            @click="btnCmd('biz1#excelDownload')"
            style="float: right"
          >
            <i class="c-icon icon-xlsx size-medium"></i>
            <span>다운로드</span>
          </button>
        </div>
      </div>
      <!-- D: pc 전용 -->
      <template v-if="data.biz1.list && data.biz1.list.length > 0">
        <div class="scroll-x only-pc">
          <div class="scroll-x-inner">
            <div class="c-table" style="width: 1400px">
              <table>
                <caption>
                  개인정보에 관한 민원서비스 테이블
                </caption>
                <colgroup>
                  <col style="width: 13%" />
                  <col style="width: 13%" />
                  <col style="width: 12%" />
                  <col style="width: 18%" />
                  <col style="width: 10.9%" />

                  <col style="width: 10%" />

                  <col style="width: 20.6%" />
                  <col style="width: 20.6%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>페인트 프로<br />주문번호</th>
                    <th>SAP<br />주문번호</th>
                    <th>주문일자</th>
                    <th>제품</th>
                    <th>주문금액</th>
                    <th>배송방법</th>
                    <th>배송지</th>
                    <th>상태</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="data.biz1.list && data.biz1.list.length > 0">
                    <ProdListTabRow
                      v-for="(item, index) in data.biz1.list"
                      :key="item.rkey"
                      :index="index"
                      :item="item"
                    />
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
      <!-- // D: pc 전용 -->
      <!-- D: mo 전용 -->
      <div class="mo-order-result-area">
        <ul class="result-list">
          <template v-if="data.biz1.list && data.biz1.list.length > 0">
            <MoProdListTabRow
              v-for="(item, index) in data.biz1.list"
              :key="item.rkey"
              :index="index"
              :item="item"
            />
          </template>
        </ul>
      </div>
      <!-- // D: mo 전용 -->

      <!-- D: no data -->
      <template v-if="data.biz1.hasNoData && data.biz1.list.length < 1">
        <div class="c-no-data-box">
          <div class="icon-box">
            <i class="c-icon icon-nodata size-large"></i>
          </div>
          <p class="text">
            기간 내 조회 결과가 없습니다. <br />
            조회 조건을 다시 입력해주세요.
          </p>
        </div>
      </template>
    </div>
    <!-- // D : 주문서 영역 -->

    <!-- D : pageing area -->
    <template v-if="data.biz1.list && data.biz1.list.length > 0">
      <Pagination
        ref="paginationEl"
        :total-pages="data.biz1.totalPage"
        :per-page="data.biz1.limit"
        :show-select="true"
        @page-change="handlePageChange_biz1"
        @items-per-page-change="handleItemsPerPageChange_biz1"
      />
    </template>
    <!-- // D : pageing area -->
  </div>
  <MoDeepInqueryPop
    v-if="data.popup.showInqueryPopup"
    :filter="data.biz1.search"
    :div="data.page.div"
    @search="(param) => btnCmd('biz1#moSearch', { search: param })"
    @close="data.popup.showInqueryPopup = false"
  />
</template>
<script setup>
import {
  onMounted,
  ref,
  reactive,
  inject,
  computed,
  defineProps,
  watch,
  onBeforeUnmount,
} from "vue";
import Pagination from "@/components/paintpro/base/pagination.vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
import { api } from "@/plugins/api";
import $ from "jquery";
import { useRoute } from "vue-router";
import MoDeepInqueryPop from "./moDeepInqueryPop.vue";
import ProdListTabRow from "./prodListTabRow.vue";
import MoProdListTabRow from "./moProdListTabRow.vue";
import { throttle } from "lodash";

const props = defineProps({
  statusCd: {
    type: String,
    required: true,
  },
  dlvCd: {
    type: String,
    required: true,
  },
});

const url = inject("url_prefix");
const orderDateStRef = ref(null);
const orderDateEdRef = ref(null);
const paginationEl = ref(null);
const route = useRoute();
const searchPeriod = ref([
  { name: "1주일", value: "week" },
  { name: "1개월", value: "month" },
  { name: "6개월", value: "half-year" },
  { name: "1년", value: "year" },
]);
const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});
const statusCdNm = computed(() => {
  const found = data.codes.code01.find(
    (item) => item.cdVl == data.biz1.search.orderStatusCd
  );
  return found ? found.cdNm : "전체";
});
const dlvCdNm = computed(() => {
  const found = data.codes.code02.find(
    (item) => item.cdVl == data.biz1.search.selectedDlvCd
  );
  return found ? found.cdNm : "전체";
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    query: {},
    deviceType: isMobile.value ? "M" : "P",
    path: "",
    div: "orderList",
  },
  codes: {
    code01: [], // 주문상태코드
    code02: [],
  },
  popup: { showInqueryPopup: false },
  // 주문내역 주문서
  biz1: {
    mode: "", // 모드 {"", "new", "view", "edit"}
    search: {
      searchDateSt: "", // 시작 주문일자
      searchDateEd: "", // 끝 주문일자
      orderStatusCd: "", // 주문상태코드
      selectedDlvCd: "",
      searchQuery: "", // 검색어
      searchPeriod: "",
      useYn: "Y",
      orderBy: "",
    },
    resDateSt: "",
    resDateEd: "",
    search_init: {}, // 검색 파라메터 초기값
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    loading: false,
    hasNoData: false,
    detail: [],
    cancelMsg: "",
    orderEmpInfo: {},
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  searchCmd("biz1#search");
  jqueryDatepicker();
  // 스크롤 이벤트 등록
  if (data.page.deviceType == "M") {
    document.addEventListener("scroll", handleScroll);
  }
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "ZTRANS_STATUS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "DLV_MTHD_CD" } });
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }
  const { cmCode_code1 } = res.data;
  const { cmCode_code2 } = res.data;

  data.page.path = route.path;
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;
  data.codes.code01 = cmCode_code1;
  data.codes.code02 = cmCode_code2;

  const orderStatusCdAll = { cdNm: "전체", cdVl: "" };
  const selectedDlvCdAll = { cdNm: "전체", cdVl: "" };
  data.codes.code01.unshift(orderStatusCdAll);
  data.codes.code02.unshift(selectedDlvCdAll);
  data.biz1.search.searchPeriod = "month"; // 검색조건 기간 스타일 적용
  dateCalculation("month");

  // 메인화면에서 넘어온경우
  data.biz1.search.orderStatusCd = route.query.statusCd || "";
  // 메인화면에서 넘어온경우
  data.biz1.search.selectedDlvCd = route.query.dlvCd || "";

  // ◼◼◼ 초기데이타 백업
  data.biz1.search_init = { ...data.biz1.search };
}

/**********************
 * 리셋 모음
 *********************/
async function resetCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#reset") {
    // ◼◼◼ biz1 초기화
    data.biz1.search = { ...data.biz1.search_init };
    dateCalculation("month");
  } else {
    alert(
      `[개발확인] resetCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#search") {
    if (
      calculateDateDifference(
        data.biz1.search.searchDateSt,
        data.biz1.search.searchDateEd
      )
    ) {
      cmUtil.alert("조회기간은 최대 1년입니다.\n날짜를 다시 선택해주세요.");
      return;
    }
    const res = await api.get(`${url}/order/selectOrderListByProd`, {
      params: {
        ...data.biz1.search,
        page: parms["page"] || 1,
        limit: parms["limit"] || data.biz1.limit,
      },
    });
    if (parms["page"] == null || parms["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }
    data.biz1.list = res.data.list;
    data.biz1.page = parms["page"] || 1;
    data.biz1.totalCount = res.data.totalCount;
    data.biz1.totalPage = data.biz1.totalCount
      ? Math.ceil(data.biz1.totalCount / data.biz1.limit)
      : 0;
    data.biz1.resDateSt = data.biz1.search.searchDateSt;
    data.biz1.resDateEd = data.biz1.search.searchDateEd;
    if (data.biz1.list.length > 0) {
      data.biz1.hasNoData = false;
    } else {
      data.biz1.hasNoData = true;
    }
  } else if (cmd === "biz1#scroll") {
    if (
      calculateDateDifference(
        data.biz1.search.searchDateSt,
        data.biz1.search.searchDateEd
      )
    ) {
      cmUtil.alert("조회기간은 최대 1년입니다.\n날짜를 다시 선택해주세요.");
      return;
    }
    const res = await api.get(`${url}/order/selectOrderListByProd`, {
      params: {
        ...data.biz1.search,
        page: parms["page"] || 1,
        limit: parms["limit"] || data.biz1.limit,
      },
    });

    if (res.data.list.length > 0) {
      data.biz1.list.push(...res.data.list);
      data.biz1.page = parms["page"] || 1;
      data.biz1.totalCount = res.data.totalCount;
      data.biz1.totalPage = data.biz1.totalCount
        ? Math.ceil(data.biz1.totalCount / data.biz1.limit)
        : 0;
      data.biz1.resDateSt = data.biz1.search.searchDateSt;
      data.biz1.resDateEd = data.biz1.search.searchDateEd;
      data.biz1.hasNoData = false;
    } else {
      data.biz1.hasNoData = true;
    }
  }
}

async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#excelDownload") {
    try {
      const response = await fetch(
        `${url}/order/prodExcelDownload?searchDateSt=${data.biz1.search.searchDateSt}&searchDateEd=${data.biz1.search.searchDateEd}&searchQuery=${data.biz1.search.searchQuery}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${cmUtil.getLocalStorage("token")}`,
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `(제품별)주문현황_${cmUtil.getToday("yyyyMMddHHmmss")}.xlsx`;
        link.click();
      } else {
        const errorMessage = await response.text();
        alert(`파일 다운로드 실패: ${errorMessage}`);
      }
    } catch (error) {
      alert(`네트워크 오류: ${error.message}`);
    }
  } else if (cmd === "biz1#searchPopup") {
    if (data.page.deviceType == "M") {
      data.popup.showInqueryPopup = true;
    }
  } else if (cmd === "biz1#moSearch") {
    data.biz1.search = { ...parms.search };
    data.popup.showInqueryPopup = false;

    searchCmd("biz1#search");
  }
}

watch(
  () => props.statusCd,
  (newValue) => {
    resetCmd("biz1#reset");
    if (newValue === "all") {
      data.biz1.search.orderStatusCd = "";
    } else {
      data.biz1.search.orderStatusCd = newValue;
    }
    searchCmd("biz1#search");
  }
);

watch(
  () => props.dlvCd,
  (newValue) => {
    resetCmd("biz1#reset");
    if (newValue === "all") {
      data.biz1.search.selectedDlvCd = "";
    } else {
      data.biz1.search.selectedDlvCd = newValue;
    }
    searchCmd("biz1#search");
  }
);

const datePair = computed(() => [
  data.biz1.search.searchDateSt,
  data.biz1.search.searchDateEd,
]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.biz1.search.searchDateSt = oldStartDate;
      data.biz1.search.searchDateEd = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.<br>다시 확인해주세요."
      );
    }
  }
);

// 검색 기간 계산
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);
  switch (period) {
    case "week":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "year":
      resultDate.setDate(today.getDate() - 364);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);
  data.biz1.search.searchDateSt = resultDate;
  data.biz1.search.searchDateEd = todayDate.value;
}

function handlePageChange_biz1(page) {
  searchCmd("biz1#search", { page: page });
}

function handleItemsPerPageChange_biz1(perPage) {
  data.biz1.limit = perPage;
  searchCmd("biz1#search");
}

// jquery 달력
function jqueryDatepicker() {
  if (orderDateStRef.value == null) return;
  $(orderDateStRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateSt = dateText;
      data.biz1.search.searchPeriod = "all";
    },
  });
  if (orderDateEdRef.value == null) return;
  $(orderDateEdRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateEd = dateText;
      data.biz1.search.searchPeriod = "all";
    },
  });
}

// 날짜 차이를 계산하는 함수
function calculateDateDifference(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const msInOneDay = 1000 * 60 * 60 * 24;
  const timeDifference = Math.abs(endDate - startDate);
  const dayDifference = timeDifference / msInOneDay;

  // 1년(365일) 이상의 차이가 있는지 확인
  return dayDifference >= 365;
}

const handleScroll = throttle(() => {
  if (
    data.page.deviceType != "M" ||
    data.biz1.hasNoData ||
    data.biz1.loading ||
    data.biz1.list.length === 0
  ) {
    return;
  }
  data.biz1.loading = true;

  const scrollPosition = window.innerHeight + window.scrollY;
  const bottom = document.documentElement.scrollHeight;

  if (scrollPosition >= bottom - 350) {
    searchCmd("biz1#scroll", { page: data.biz1.page + 1 });
  }
  data.biz1.loading = false;
}, 300);

onBeforeUnmount(() => {
  document.removeEventListener("scroll", handleScroll);
});
</script>
